import React, { Component } from "react";
import { hideLoading, showErrorMessage, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import cfg from "@eres/ejari-api/config";
import { trackEvent, trackEventWithData } from "@my-dld/utils/Analytics";
import { openPayment } from "@my-dld/utils/Utils";
import Strings from "@my-dld/assets/strings";
import { StringUtil } from "@eres/core";

interface Props {
	contractNumber: string;
	prefixUrl?: string;
}

type PaymentCallback = ( isSuccess: boolean, data: any ) => void;

class PayForContract extends Component<Props> {
	initPayment = ( callback?: PaymentCallback ) => {
		let cn = this.props.contractNumber;
		let prefixUrl = this.props.prefixUrl;
		let paymentURL = cfg.ejariAPI().endPoint() + cfg.ejariAPI().paymentPage() + `?code=${ cn }&emb=true`;
		if ( prefixUrl ) {
			paymentURL = paymentURL + prefixUrl;
		}
		let win: Window | null = null;
		const t = this;
		let handled = false;
		window.name = "MyDLD";
		trackEventWithData( "EjariContract", "TryPay", {
			number: cn
		} );
		const listener = ( event: any ) => {
			const data: any = event.data;
			if ( data ) {
				const type = data.type;
				if ( type === "eres_pay" ) {
					window.removeEventListener( "message", listener );
					window.open( "", "MyDLD" )?.focus();
					if ( win ) {
						handled = true;
						if ( win.close )
							win.close();
						window.focus();
					}
					setTimeout( () => {
						hideLoading();
						let rsp = data.data;
						if ( rsp == null || rsp.refNumber == null || StringUtil.isEmptyStringOrNull( rsp.refNumber ) ) {
							trackEvent( "EjariContract", "PaymentFailed" );
							let message = Strings.payment_failed;
							if ( rsp && rsp.message != undefined ) message = message + "\n" + rsp.message;
							showMessage( message );
							if ( callback ) callback( false, data );
						} else {
							trackEvent( "EjariContract", "PaymentSuccess" );
							if ( callback ) callback( true, data );
						}
					}, 1 );
				}
			}
		};
		window.addEventListener( "message", listener, false );
		win = openPayment( paymentURL );
		if ( win ) {
			let x = win as any;
			showLoading();
			this.checkWindow( paymentURL, x, listener ).then( w => {
				win = w;
				const pollTimer = window.setInterval( function () {
					if ( !handled && win!.closed ) {
						window.clearInterval( pollTimer );
						window.removeEventListener( "message", listener );
						hideLoading();
					}
				}, 200 );
			} ).catch( e => {
				hideLoading();
			} );
		} else {
			showErrorMessage( "Enable Popup window to continue" );
		}
	};
	checkWindow = async ( url: string, win: any, listener: any ) => {
		try {
			win.addEventListener( "message", listener, false );
			return Promise.resolve( win );
		} catch ( e ) {
			win.close();
			return new Promise<any>( ( resolve, reject ) => {
				setTimeout( () => {
					win = openPayment( url );
					win.addEventListener( "message", listener, false );
					resolve( win );
				}, 1000 );
			} );
		}
	};

	render() {
		return null;
	}
}

export default PayForContract;
